import { createFileRoute } from "@tanstack/react-router";
import { Analytics } from "@/components/Analytics";

function RouteComponent() {
  return <Analytics />;
}

export const Route = createFileRoute("/_authenticated/logs/api/")({
  component: RouteComponent,
  staticData: { page: ["engineering", "analytics", "admin"] },
});
